import { useContext } from 'react';

import { TeamContext } from '../contexts/TeamContext';

const useTeam = () => useContext(TeamContext);

export default useTeam;
